import React from 'react';

const MarcaDetailModal = ({ marca, onClose }) => {
    if (!marca) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
            <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl max-h-[90vh] overflow-y-auto">
                <div className="p-6">
                    <div className="flex justify-between items-start mb-6">
                        <h2 className="text-2xl font-bold text-gray-900">Detalles de la Marca</h2>
                        <button
                            onClick={onClose}
                            className="text-gray-400 hover:text-gray-500"
                        >
                            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>

                    <div className="space-y-6">
                        {/* Información básica */}
                        <div className="flex items-center space-x-4">
                            {marca.logotipo && (
                                <img
                                    src={marca.logotipo.cdnUrl}
                                    alt={marca.nombre}
                                    className="h-16 w-16 object-cover rounded-lg"
                                />
                            )}
                            <div>
                                <h3 className="text-xl font-semibold text-gray-900">{marca.nombre}</h3>
                                <p className="text-gray-500">{marca.rubro || 'Rubro no especificado'}</p>
                            </div>
                        </div>

                        {/* Detalles principales */}
                        <div className="grid grid-cols-2 gap-4">
                            <div className="bg-gray-50 p-4 rounded-lg">
                                <h4 className="text-sm font-medium text-gray-500">Sistema de Puntos</h4>
                                <p className="mt-1 text-lg font-semibold">{marca.puntosTicket} puntos por ticket</p>
                                <p className="text-sm text-gray-500">{marca.puntos}</p>
                            </div>
                            <div className="bg-gray-50 p-4 rounded-lg">
                                <h4 className="text-sm font-medium text-gray-500">Estadísticas</h4>
                                <div className="mt-1">
                                    <p className="text-sm">
                                        <span className="font-medium">{marca.tiendas?.length || 0}</span> tiendas
                                    </p>
                                    <p className="text-sm">
                                        <span className="font-medium">{marca.clientes?.length || 0}</span> clientes
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Identidad visual */}
                        <div className="bg-gray-50 p-4 rounded-lg">
                            <h4 className="text-sm font-medium text-gray-500 mb-3">Identidad Visual</h4>
                            <div className="space-y-3">
                                <div>
                                    <span className="text-sm text-gray-500">Tipografía:</span>
                                    <span className="ml-2 font-medium">{marca.tipografia || 'No especificada'}</span>
                                </div>
                                {marca.coloresCorporativos?.length > 0 && (
                                    <div>
                                        <span className="text-sm text-gray-500">Colores corporativos:</span>
                                        <div className="flex gap-2 mt-2">
                                            {marca.coloresCorporativos.map((color, index) => (
                                                <div
                                                    key={index}
                                                    className="w-8 h-8 rounded-full border"
                                                    style={{ backgroundColor: color }}
                                                    title={color}
                                                />
                                            ))}
                                        </div>
                                    </div>
                                )}
                                {marca.eslogan && (
                                    <div>
                                        <span className="text-sm text-gray-500">Eslogan:</span>
                                        <p className="mt-1 italic">{marca.eslogan}</p>
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Preferencias de notificación */}
                        <div className="bg-gray-50 p-4 rounded-lg">
                            <h4 className="text-sm font-medium text-gray-500 mb-3">Preferencias de Notificación</h4>
                            <div className="space-y-2">
                                <div className="flex items-center">
                                    <span className="text-sm">Email:</span>
                                    <span className={`ml-2 ${marca.notificationPreferences?.email ? 'text-green-600' : 'text-red-600'}`}>
                                        {marca.notificationPreferences?.email ? 'Activado' : 'Desactivado'}
                                    </span>
                                </div>
                                <div className="flex items-center">
                                    <span className="text-sm">WhatsApp:</span>
                                    <span className={`ml-2 ${marca.notificationPreferences?.whatsapp ? 'text-green-600' : 'text-red-600'}`}>
                                        {marca.notificationPreferences?.whatsapp ? 'Activado' : 'Desactivado'}
                                    </span>
                                </div>
                            </div>
                        </div>

                        {/* Información adicional */}
                        {marca.pointscondition && (
                            <div className="bg-gray-50 p-4 rounded-lg">
                                <h4 className="text-sm font-medium text-gray-500 mb-2">Condición de Puntos</h4>
                                <p className="text-sm">{marca.pointscondition}</p>
                            </div>
                        )}

                        <div className="bg-gray-50 p-4 rounded-lg">
                            <h4 className="text-sm font-medium text-gray-500 mb-2">Información del Propietario</h4>
                            {marca.owner ? (
                                <div className="text-sm">
                                    <p><span className="font-medium">Nombre:</span> {marca.owner.nombre}</p>
                                    <p><span className="font-medium">Email:</span> {marca.owner.email}</p>
                                </div>
                            ) : (
                                <p className="text-sm text-gray-500">Sin propietario asignado</p>
                            )}
                        </div>

                        <div className="text-sm text-gray-500">
                            Creada el: {new Date(marca.createdAt).toLocaleDateString()}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MarcaDetailModal; 